import appConfig from '@nerdwallet/app-config';
import { getLogger } from '@nerdwallet/logging';
import { AnalyticsBrowser } from '@segment/analytics-next';
import { v4 as uuidv4 } from 'uuid';

import Cookies from 'universal-cookie';

const cookies = new Cookies();
export const getCookie = (cookieName: string): any => cookies.get(cookieName);

const segmentTrackingLogger = getLogger('SegmentTracking');
const segmentAnalytics =
  appConfig?.SEGMENT?.WRITE_KEY && typeof window !== 'undefined'
    ? AnalyticsBrowser.load(
        {
          writeKey: appConfig?.SEGMENT?.WRITE_KEY, // this is a test value
          cdnURL: appConfig?.SEGMENT?.CDN_URL,
        },
        {
          cookie: {
            domain: appConfig?.SEGMENT?.DOMAIN,
            maxage: appConfig?.SEGMENT?.MAX_AGE,
            secure: appConfig?.SEGMENT?.SECURE,
          },
          integrations: {
            'Segment.io': {
              apiHost: appConfig?.SEGMENT?.API_HOST,
              protocol: appConfig?.SEGMENT?.PROTOCOL,
            },
          },
        }
      )
    : null;

export type DefaultPagePayload = {
  /* eslint-disable-next-line camelcase */
  traditional_device_id: string;
  /* eslint-disable-next-line camelcase */
  pageview_id: string;
  /* eslint-disable-next-line camelcase */
  deployable_name: string;
  /* eslint-disable-next-line camelcase */
  deployable_version: string;
};

export type DefaultImpressionPayload = {
  /* eslint-disable-next-line camelcase */
  traditional_device_id: string;
  /* eslint-disable-next-line camelcase */
  deployable_name: string;
  /* eslint-disable-next-line camelcase */
  deployable_version: string;
};

export const trackSegmentTrackEvent = (
  eventName: string,
  pageViewId: string,
  eventProps: Record<string, any> = {}
): void => {
  const defaultPayload: DefaultImpressionPayload = {
    traditional_device_id: getCookie('cookie_id'),
    // eslint-disable-next-line no-underscore-dangle
    deployable_name: appConfig?._meta?.deployable,
    // eslint-disable-next-line no-underscore-dangle
    deployable_version: appConfig?._meta?.version,
  };

  try {
    segmentAnalytics?.track(eventName, {
      pageview_id: pageViewId,
      ...defaultPayload,
      ...eventProps,
    });
  } catch (e) {
    console.log('segment error', e);
    segmentTrackingLogger.error(e);
  }
};

export const segmentImpressionId = uuidv4();
